import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

import { lightenDarkenColor } from 'utils/colorConvert';
import { stylePropType } from 'utils/propTypes';
import { componentStylePropTypes } from 'client/gameFormBased/utils/propTypes';

import ButtonWithLoadingEffect from 'Mui/ButtonWithLoadingEffect';

function SuccessButton({
    id,
    isLoading,
    style,
    onClick = () => {},
    text,
    children,
    disabled,
    componentStyle = {},
    textStyle
}) {
    return (
        <ButtonWithLoadingEffect
            id={id}
            css={[
                btnStyle({
                    color: componentStyle.buttonTextColor,
                    bgColor: componentStyle.buttonBgColor,
                    disableColor: componentStyle.disableColor,
                    disableBgColor: componentStyle.disableBgColor
                }),
                css(style)
            ]}
            variant="contained"
            disabled={disabled}
            onClick={onClick}
            isLoading={isLoading}
        >
            {children ? (
                children
            ) : (
                <Typography variant="h6" css={textStyle}>
                    {text}
                </Typography>
            )}
        </ButtonWithLoadingEffect>
    );
}

SuccessButton.propTypes = {
    style: stylePropType,
    onClick: PropTypes.func,
    text: PropTypes.string,
    disabled: PropTypes.bool,
    componentStyle: componentStylePropTypes,
    isLoading: PropTypes.bool
};

export default SuccessButton;

const btnStyle = ({ color = '#fff', bgColor = '#000', disableColor, disableBgColor } = {}) => css`
    padding: 12px 24px;
    width: 100%;
    max-width: 320px;
    background-color: ${bgColor};
    border-radius: 28px;
    font-size: 20px;
    & * {
        color: ${color};
    }
    &.MuiButton-contained.Mui-disabled {
        color: ${Boolean(disableColor) ? disableColor : '#fff'};
        ${Boolean(disableBgColor) && `background-color:${disableBgColor}`}
    }
    &:hover {
        background-color: ${lightenDarkenColor(bgColor, 0.1)};
    }
`;
